import { toast } from "react-toastify";
import { BACKEND } from "../config/configEnvs"
import axios from "axios";

const DeleteItem = async (targetID, route, setElements, showToast = true) => {
  try {

    const c = window.confirm("¿Seguro quieres eliminar este ítem?")

    if (c) {
      await axios.delete(`${BACKEND}/api/${route}/${targetID}`)

      setElements((p) => p.filter((e) => e.id !== targetID))
  
      if (showToast) toast.success("ítem eliminado con éxito");
    }

  } catch (e) {
    if (showToast) toast.error("Error al eliminar el ítem: " + e);
  }
}

export default DeleteItem